import { clsx } from "clsx";
import { Check, Clock } from "lucide-react";

// Mirrors mobile's GuestStatusPill, without a disclosure icon for a static status.
export function GuestStatusBadge({ label, tone = "green", claimState }: {
  label: string;
  tone?: "green" | "pink" | "neutral";
  claimState?: "claimed" | "unclaimed";
}) {
  if (claimState) {
    const Icon = claimState === "claimed" ? Check : Clock;
    return (
      <span className="inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap font-sans text-sm text-butter-pink">
        <Icon aria-hidden className="size-3.5" />
        {label}
      </span>
    );
  }
  return (
    <span className={clsx(
      "inline-flex h-[26px] shrink-0 items-center whitespace-nowrap rounded-full border px-4 font-sans text-[12px] leading-5 font-semibold tracking-[-0.12px]",
      tone === "green" && "border-butter-lime bg-butter-lime/15 text-butter-green",
      tone === "pink" && "border-butter-pink bg-butter-pink/15 text-butter-pink",
      tone === "neutral" && "border-butter-cream bg-butter-cream/15 text-butter-green",
    )}>
      {label}
    </span>
  );
}
